import {AuthApplication} from '@application/Auth';
import {eventManager} from '@application/Event';
import {UserEvent} from '@domain/model/Event';

import {Modality, MODALITY_MAPPING} from '@domain/model/Account/Subscription/Subscription';

export const emitEventSubscriptionCancelled = async (modality: Modality): Promise<void> => {
  const {id: userId} = await AuthApplication.getLoginInfo();
  eventManager.emit(UserEvent.SUBSCRIPTION_CANCELLED, {
    subscription: MODALITY_MAPPING[modality],
    userId,
  });
};

type LkDayInfo = {
  previousFrequencyDay?: number;
  currentFrequencyDay?: number;
};

export const emitEventSubscriptionUpdated = async (
  modality: Modality,
  selectedModality: Modality,
  lkDayInfo: LkDayInfo = {},
): Promise<void> => {
  const {id: userId} = await AuthApplication.getLoginInfo();
  eventManager.emit(UserEvent.SUBSCRIPTION_UPDATED, {
    subscription: MODALITY_MAPPING[modality],
    newSubscription: MODALITY_MAPPING[selectedModality],
    previousFrequencyDay: lkDayInfo.previousFrequencyDay,
    currentFrequencyDay: lkDayInfo.currentFrequencyDay,
    userId,
  });
};
